import { trainingCenterList, states, cities } from "constants/trainingCenter";

const initialState = {
  trainingCenterList:{},
  states: {},
  cities: {},
};

const trainingCenters = (state = initialState, action) => {
  switch (action.type) {
    case trainingCenterList:
      return { ...state, trainingCenterList: action.payload };

    case states:
      return { ...state, states: action.payload };

    case cities:
      return { ...state, cities: action.payload };

    default:
      return state;
  }
};

export default trainingCenters;
